import { GridRowModel, GridValueGetterParams, GridValueSetterParams } from '@mui/x-data-grid-pro';
import lodash from 'lodash';

export default class DataGridHelper {
    public static nestedValueFieldGetter = <R extends { [key : string] : unknown }, V>(params : GridValueGetterParams<R, V>) : R[string] => {
        return lodash.get(params.row, params.field);
    };

    public static getRowId = (row : GridRowModel<Record<string, unknown>>, useGuidAsParamsIdType : boolean | undefined) : string | number => {
        if (!useGuidAsParamsIdType && 'id' in row && typeof row.id === 'number' && row.id > 0) {
            return row.id;
        }

        if ('guid' in row && typeof row.guid === 'string' && row.guid !== '') {
            return row.guid;
        }

        throw new Error('id or guid field required.');
    };

    // eslint-disable-next-line @typescript-eslint/ban-types
    public static nestedValueFieldSetter = <R extends object, V>(
        params : GridValueSetterParams<R, V>,
        field : string,
    ) : R => {
        const value = params.value;
        const row = { 
            ...params.row,
        };
        lodash.set(row, field, value);
        return row;
    };
}